<template>
  <topics-loader>
    <mc-app-header title="Add Topic">
      <template v-slot:right>
        <div class="level-item">
          <b-button
            :loading="topics.submitting"
            type="is-primary"
            @click="addTopicHandler"
          >
            Add
          </b-button>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="add-topic section">
        <form class="mc-container" @submit.prevent="addTopicHandler">
          <b-field label="Name">
            <b-input
              v-model="name"
              icon="format-title"
              placeholder="Name"
              type="text"
            />
          </b-field>
          <b-field label="Poster">
            <mc-image-input
              v-model="poster"
              icon="image"
              placeholder="Poster Link"
              type="POSTER"
            />
          </b-field>
          <b-field label="Estimated # of Classes">
            <b-input
              v-model.number="classCount"
              icon="numeric"
              placeholder="Estimated # of classes"
              type="number"
            />
          </b-field>
        </form>
      </div>
    </mc-app-body>
  </topics-loader>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import maxBy from 'lodash/maxBy';

import TopicsLoader from './TopicsLoader';

export default {
  data: function() {
    return {
      name: '',
      poster: '',
      classCount: null
    };
  },
  computed: {
    ...mapState(['topics'])
  },
  methods: {
    ...mapActions('topics', ['addTopic']),
    async addTopicHandler() {
      try {
        let lastTopic = maxBy(this.topics.list, 'serialNumber');
        await this.addTopic({
          name: this.name,
          poster: this.poster,
          serialNumber: lastTopic ? lastTopic.serialNumber + 1 : 1,
          classCount: this.classCount,
          publishedConceptCount: 0
        });
        this.$buefy.toast.open({
          message: 'Topic added successfully!',
          type: 'is-success'
        });
        this.$router.replace(`/topics/edit/${this.topics.newTopicId}`);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add topic!',
          type: 'is-danger'
        });
      }
    }
  },
  components: {
    TopicsLoader
  }
};
</script>
